import React, { useState, useEffect, useRef } from "react";
import "./App.css";
import { motion } from "framer-motion";
import HandwritingAnimation from "./component/HandwritingAnimation";
import { PATHS } from "./assets/writingData";
import { MASKDATAS } from "./assets/maskingData";

export const TARGET_DATE = "2025-09-20 12:30:00";

const KAKAO_APP_KEY = "8480c3fb2550765f69796bfd2cee222d";

function App() {
    const [shouldRender, setShouldRender] = useState(false);

    const ua = navigator.userAgent.toLowerCase();
    const currentUrl = window.location.href;

    const isIOS = /iphone|ipad|ipod/.test(ua);
    const isKakao = /kakaotalk/.test(ua);

    const openExternal = (url) => {
        const encoded = encodeURIComponent(url);
        window.location.href = `kakaotalk://web/openExternal?url=${encoded}`;
    };

    const [LoadedImageSection, setLoadedImageSection] = useState(null);
    const [LoadedCalendarSection, setLoadedCalendarSection] = useState(null);
    const [LoadedGallerySection, setLoadedGallerySection] = useState(null);
    const [LoadedMapSection, setLoadedMapSection] = useState(null);
    const [LoadedAccountSection, setLoadedAccountSection] = useState(null);
    const [LoadedKakaoShareButton, setLoadedKakaoShareButton] = useState(null);

    useEffect(() => {
        // 카카오 인앱이면 외부 브라우저로 열고 닫기
        const closeInApp = () => {
            if (isIOS) {
                window.location.href = "kakaoweb://closeBrowser";
            }
        };

        // if (isKakao) {
        // openExternal(currentUrl);
        // setTimeout(closeInApp);
        // } else {
        // 일반 브라우저면 렌더링 허용
        setShouldRender(true);
        // }
    }, [isKakao, currentUrl, isIOS]);
    // ────────────────────────────────────────────────────────────────────────

    // 카카오 인앱이면 null 리턴

    const [scrolled, setScrolled] = useState(false);
    const [isAnimating, setIsAnimating] = useState(false); // 애니메이션 진행 여부
    // const [isWriting, setIsWriting] = useState(false);
    const [mainLoad, setMainLoad] = useState(false);
    const [CompoLoad, setCompoLoad] = useState(false);
    const contentRef = useRef(null);
    const [spacerHeight, setSpacerHeight] = useState(0);
    const writingRef = useRef();

    useEffect(() => {
        if (!window.Kakao.isInitialized()) {
            window.Kakao.init(KAKAO_APP_KEY);
            console.log("Kakao SDK Initialized:", window.Kakao.isInitialized());
        }
    }, []);

    useEffect(() => {
        const handleScroll = (e) => {
            e.preventDefault();
            if (window.scrollY > 0) {
                setScrolled(true);
            } else {
                setScrolled(false);
            }
        };

        document.addEventListener("scroll", handleScroll, { passive: false });
        return () =>
            document.removeEventListener("scroll", handleScroll, {
                passive: false,
            });
    }, []);

    useEffect(() => {
        if (scrolled) writingRef.current?.complete();
    }, [scrolled]);

    useEffect(() => {
        const prevent = (e) => e.preventDefault();

        // 터치 시작 이벤트 핸들러
        const handleTouchStart = (e) => {
            // 두 손가락 이상 터치 (핀치 투 줌) 감지 시 확대 방지
            if (e.touches.length > 1) {
                e.preventDefault();
            }
        };

        // 터치 이동 이벤트 핸들러
        const handleTouchMove = (e) => {
            // 두 손가락 이상 터치 (핀치 투 줌) 감지 시 확대 방지
            if (e.touches.length > 1) {
                e.preventDefault();
            }
        };

        const lockScroll = (e) => {
            e.preventDefault();

            if (isAnimating || !CompoLoad) {
                // if (isAnimating || !isWriting) {
                if (scrolled) {
                    window.scrollTo(0, 1); // 애니메이션이 -100%로 갈 때
                } else {
                    window.scrollTo(0, 0); // 애니메이션이 0%로 돌아올 때
                }
            }
        };

        const handleWheel = (e) => {
            if (e.ctrlKey || e.metaKey) {
                e.preventDefault();
            }
        };

        const opts = { passive: false, capture: true };

        document.addEventListener("touchstart", handleTouchStart, opts);
        window.addEventListener("mousewheel", handleWheel, opts);
        window.addEventListener("DOMMouseScroll", handleWheel, opts);
        window.addEventListener("wheel", handleWheel, opts);
        document.addEventListener("gesturestart", prevent, opts);
        document.addEventListener("gesturechange", prevent, opts);
        document.addEventListener("gestureend", prevent, opts);
        document.addEventListener("contextmenu", prevent, opts);
        document.addEventListener("dragstart", prevent, opts);
        document.addEventListener("copy", prevent, opts);
        document.addEventListener("touchmove", handleTouchMove, opts);
        document.addEventListener("scroll", lockScroll, opts);

        if (isAnimating || !CompoLoad) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "auto";
        }

        return () => {
            document.body.style.overflow = "auto";
            document.removeEventListener("touchstart", handleTouchStart, opts);
            window.removeEventListener("mousewheel", handleWheel, opts);
            window.removeEventListener("DOMMouseScroll", handleWheel, opts);
            window.removeEventListener("wheel", handleWheel, opts);
            document.removeEventListener("gesturestart", prevent, opts);
            document.removeEventListener("gesturechange", prevent, opts);
            document.removeEventListener("gestureend", prevent, opts);
            document.removeEventListener("contextmenu", prevent, opts);
            document.removeEventListener("scroll", lockScroll, opts);
            document.removeEventListener("copy", prevent, opts);
            document.removeEventListener("touchmove", handleTouchMove, opts);
            document.removeEventListener("dragstart", prevent, opts);
        };
    }, [isAnimating, scrolled, CompoLoad]);

    useEffect(() => {
        if (mainLoad) {
            Promise.all([
                import("./section/ImageSection"), // ImageSection 추가
                import("./section/CalendarSection"),
                import("./section/GallerySection"),
                import("./section/MapSection"),
                import("./section/AccountSection"), // AccountSection 추가
                import("./component/KakaoShareButton"),
            ])
                .then(
                    ([
                        ImageMod, // 로드된 모듈들
                        CalendarMod,
                        GalleryMod,
                        MapMod,
                        AccountMod,
                        KakaoMod,
                    ]) => {
                        // 로드된 컴포넌트들을 state에 저장합니다.
                        // .default를 붙이는 이유는 import()가 모듈 객체를 반환하고,
                        // React 컴포넌트는 보통 default export되기 때문입니다.
                        setLoadedImageSection(() => ImageMod.default);
                        setLoadedCalendarSection(() => CalendarMod.default);
                        setLoadedGallerySection(() => GalleryMod.default);
                        setLoadedMapSection(() => MapMod.default);
                        setLoadedAccountSection(() => AccountMod.default);
                        setLoadedKakaoShareButton(() => KakaoMod.default);
                        setCompoLoad(true); // 모든 컴포넌트 로드 완료 상태 설정
                    }
                )
                .catch((error) => {
                    console.error("Failed to load some components:", error);
                    // 에러 처리 로직 추가 (예: 사용자에게 오류 메시지 표시)
                });
        }
    }, [mainLoad]);

    useEffect(() => {
        const content = contentRef.current;
        if (!content) return;

        updateSpacer();
        document.addEventListener("resize", updateSpacer);
        const mo = new MutationObserver((mutations) => {
            updateSpacer();
        });
        mo.observe(content, { childList: true, subtree: true });

        return () => {
            document.removeEventListener("resize", updateSpacer);
            mo.disconnect();
        };
    }, []);

    const updateSpacer = () => {
        const content = contentRef.current;
        if (!content) return;
        const contentH = content.scrollHeight;
        const viewH = window.innerHeight;
        let newHeight = 0;

        if (contentH <= viewH) {
            newHeight = viewH - contentH + 1;
        } else {
            newHeight = 0;
        }

        setSpacerHeight(newHeight);
    };

    if (!shouldRender) {
        return null;
    }
    return (
        <div className="App">
            <div className="App" ref={contentRef}>
                <motion.div
                    className="hero-section"
                    animate={{
                        y: scrolled ? "-100%" : "0%",
                        opacity: scrolled ? 0 : 1,
                    }}
                    transition={{ duration: 1, ease: "easeOut" }}
                    onAnimationStart={() => setIsAnimating(true)} // 애니메이션 시작
                    onAnimationComplete={() => setIsAnimating(false)} // 애니메이션 완료
                >
                    <img
                        src={`${process.env.PUBLIC_URL}/first.jpeg`}
                        alt="First Page"
                        onLoad={() => {
                            setMainLoad(true);
                            writingRef.current?.play();
                        }}
                    />
                    <div className="handwrite-section">
                        <HandwritingAnimation
                            svgPaths={PATHS}
                            maskingPath={MASKDATAS}
                            onComplete={() => {
                                // setIsWriting(true);
                            }}
                            ref={writingRef}
                        />
                    </div>
                    <motion.div
                        className="downscroll-section"
                        animate={{ y: [0, -10, 0] }}
                        transition={{
                            duration: 1.2,
                            repeat: Infinity,
                            ease: "easeInOut",
                        }}
                    >
                        <div className="flex-center">
                            <span className="scrolldown-text">
                                아래로 스크롤
                            </span>
                            <svg
                                width="clamp(32px, 8vw, 48px)"
                                height="clamp(32px, 8vw, 48px)"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                className="scrolldown-svg"
                            >
                                <path d="M12 16L6 10H18L12 16Z" fill="#fff" />
                            </svg>
                        </div>
                    </motion.div>
                </motion.div>
                {CompoLoad ? (
                    <>
                        {LoadedImageSection && <LoadedImageSection />}
                        {LoadedCalendarSection && <LoadedCalendarSection />}
                        {LoadedGallerySection && <LoadedGallerySection />}
                        {LoadedMapSection && <LoadedMapSection />}
                        {LoadedAccountSection && <LoadedAccountSection />}
                        {LoadedKakaoShareButton && <LoadedKakaoShareButton />}
                    </>
                ) : (
                    // 컴포넌트 로딩 중 표시할 UI (예: 스피너)
                    <div style={{ textAlign: "center", padding: "50px" }}>
                        <h1>페이지 로딩 중...</h1>
                        <p>잠시만 기다려 주세요.</p>
                        {/* 여기에 로딩 스피너 같은 것을 추가할 수 있습니다. */}
                    </div>
                )}
            </div>

            {spacerHeight > 0 && (
                <div style={{ height: spacerHeight, width: "1px" }} />
            )}
        </div>
    );
}

export default App;
